import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Row, Button, Col } from 'react-bootstrap';

interface IHowToHeader {
  titleText: string;
  subtitleText?: string;
}

const HowToHeader = (props: IHowToHeader) => {
  return (
    <>
      <Row>
        <Col sm={9} className='text-left'>
          <h2>{props.titleText}</h2>
        </Col>
        <Col sm={3} className='text-right'>
          <Button
            className='px-5 d-print-none'
            variant='info'
            onClick={() => window.print()}
          >
            <FontAwesomeIcon icon={faPrint} />
          </Button>
        </Col>
      </Row>
      {props.subtitleText && <p>{props.subtitleText}</p>}
    </>
  );
};

export default HowToHeader;
